import * as React from 'react';

import { useVoiceboxSettings } from 'bones/components/molecules/Voicebox/context/VoiceboxSettings';
import { VoiceboxLandingCards } from 'bones/components/molecules/Voicebox/landing/VoiceboxLandingCards';
import { VoiceboxChatTextarea } from 'bones/components/molecules/Voicebox/shared/VoiceboxChatTextarea';
import { VoiceboxDescription } from 'bones/components/molecules/Voicebox/shared/VoiceboxDescription';
import { VoiceboxWelcome } from 'bones/components/molecules/Voicebox/shared/VoiceboxWelcome';

export interface VoiceboxLandingProps {
  aiReasoning: boolean;
  lastTypedQuery: string;
  query: string;
  queryHistoryIdx: number;
  sendMessage: (message: string) => void;
  sendMessageDisabled: boolean;
  setAiReasoning: (aiReasoning: boolean) => void;
  setLastTypedQuery: (query: string) => void;
  setQuery: (query: string) => void;
  setQueryHistoryIdx: (queryHistoryIdx: number) => void;
}

export const VoiceboxLanding: React.VFC<VoiceboxLandingProps> = ({
  aiReasoning,
  lastTypedQuery,
  query,
  queryHistoryIdx,
  sendMessage,
  sendMessageDisabled,
  setAiReasoning,
  setLastTypedQuery,
  setQuery,
  setQueryHistoryIdx,
}) => {
  const { settings } = useVoiceboxSettings();

  return (
    <div className="vb-voicebox-landing">
      <div className="vb-voicebox-landing-info">
        <VoiceboxWelcome />
        <VoiceboxDescription
          databaseId={settings.databaseId}
          model={settings.model}
          size="lg"
        />
      </div>
      <div className="vb-voicebox-landing-chat">
        <VoiceboxLandingCards
          sendMessage={sendMessage}
          sendMessageDisabled={sendMessageDisabled}
        />
        <div className="vb-voicebox-landing-chat-textarea">
          <VoiceboxChatTextarea
            aiReasoning={aiReasoning}
            lastTypedQuery={lastTypedQuery}
            query={query}
            queryHistoryIdx={queryHistoryIdx}
            sendMessage={sendMessage}
            sendMessageDisabled={sendMessageDisabled}
            setAiReasoning={setAiReasoning}
            setLastTypedQuery={setLastTypedQuery}
            setQuery={setQuery}
            setQueryHistoryIdx={setQueryHistoryIdx}
          />
        </div>
      </div>
    </div>
  );
};
